module.exports = __webpack_public_path__ + "media/images/leader-1-cc407d2df18edb8dc46ef0431af2fb8a.svg";